import { SCENE_VERSION_V1, SCENE_VERSION_V2 } from "../versions.js";
/** Расширенные фигуры (библиотека в духе Miro): один тип сцены, много вариантов. */
export const GEOM_KINDS = [
    // стрелки / символы
    "arrow_leftright",
    "arrow_left",
    "arrow_right",
    "arrow_updown",
    "arrow_up",
    "arrow_down",
    "chevron_right",
    "chevron_left",
    "cloud",
    "bubble",
    "thought",
    "brace",
    "heart",
    "cross",
    "plus",
    "crescent",
    // 2D
    "rounded_rect",
    "stadium",
    "hexagon",
    "pentagon",
    "octagon",
    "right_triangle",
    "left_triangle",
    "trapezoid",
    "parallelogram",
    "parallelogram_alt",
    "rhomboid",
    "banner",
    "document",
    "ring",
    // объёмные (учебная проекция)
    "sphere",
    "frustum",
    "cone",
    "cylinder",
    "pyramid",
    "pyramid_tri",
    "box",
    "oblique_box",
];
export const SHAPE_TOOL_KINDS = [
    "rect",
    "ellipse",
    "triangle",
    "diamond",
    "star",
    ...GEOM_KINDS,
];
export function isGeomKind(value) {
    return typeof value === "string" && GEOM_KINDS.includes(value);
}
export function isShapeToolKind(value) {
    return (value === "rect" ||
        value === "ellipse" ||
        value === "triangle" ||
        value === "diamond" ||
        value === "star" ||
        isGeomKind(value));
}
export const SHAPE_OBJECT_TYPES = [
    "rect",
    "ellipse",
    "triangle",
    "diamond",
    "star",
    "geom",
];
export function isShapeObjectType(value) {
    return typeof value === "string" && SHAPE_OBJECT_TYPES.includes(value);
}
const CAP_ALL = {
    move: true,
    resize: true,
    rotate: true,
    textEdit: false,
    pointEdit: false,
    styleEdit: true,
    duplicate: true,
    delete: true,
    zOrder: true,
    lock: true,
};
export const OBJECT_CAPABILITIES = {
    sticky: { ...CAP_ALL, rotate: false, textEdit: true },
    text: { ...CAP_ALL, rotate: false, textEdit: true },
    rect: { ...CAP_ALL, textEdit: false },
    ellipse: { ...CAP_ALL, textEdit: false },
    triangle: { ...CAP_ALL, textEdit: false },
    diamond: { ...CAP_ALL, textEdit: false },
    star: { ...CAP_ALL, textEdit: false },
    geom: { ...CAP_ALL, textEdit: false },
    image: { ...CAP_ALL, rotate: false },
    audio: { ...CAP_ALL, rotate: false, textEdit: false, pointEdit: false },
    path: { ...CAP_ALL, resize: true, rotate: true, pointEdit: false },
    line: { ...CAP_ALL, resize: false, rotate: false, pointEdit: true },
    arrow: { ...CAP_ALL, resize: false, rotate: false, pointEdit: true },
    pdf_document: { ...CAP_ALL, rotate: false, textEdit: false, pointEdit: false },
    timer: { ...CAP_ALL, rotate: false, textEdit: false, pointEdit: false, styleEdit: false },
    calculator: { ...CAP_ALL, rotate: false, textEdit: false, pointEdit: false, styleEdit: false },
    code: { ...CAP_ALL, rotate: false, textEdit: false, pointEdit: false, styleEdit: false },
    sql: { ...CAP_ALL, rotate: false, textEdit: false, pointEdit: false, styleEdit: false },
    frame: {
        ...CAP_ALL,
        rotate: false,
        textEdit: true,
        pointEdit: false,
        styleEdit: true,
    },
};
export function capabilitiesForType(type) {
    return OBJECT_CAPABILITIES[type];
}
export function isSceneVersion(value) {
    return value === SCENE_VERSION_V1 || value === SCENE_VERSION_V2;
}
